// extracted by mini-css-extract-plugin
module.exports = {"pageButton":"PageButton__pageButton","button":"PageButton__button"};